export default "__VITE_PUBLIC_ASSET__9cd5daed__"